import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=22e6f71a&scoped=true&"
import script from "./BackToTopButton.vue?vue&type=script&lang=ts&"
export * from "./BackToTopButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=22e6f71a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6f71a",
  null
  
)

export default component.exports